import React from 'react';
import UseContext from "hooks/useContext";

const Modalstructure = ({isShowing, children}) => {
    const { modalType } = UseContext();
    
    // Modales de validation d'identité qui nécessitent la largeur étendue
    const wideModals = [
        'ad_file_accept_identity',
        'ad_file_accept_visa',
        'ad_file_accept_simple',
        'ad_file_accept_card_vitality',
        'ad_file_refuse',
        'ad_file_view'
    ];
    
    const isWideModal = wideModals.includes(modalType);
    const maxWidthClass = isWideModal ? 'max-w-[1400px]' : 'max-w-2xl';
    
    return (
        <>
            {isShowing ?
                <>

                    <div className="flex fixed justify-center items-start inset-0 z-50 outline-none focus:outline-none p-4 overflow-y-auto">
                        <div className={`relative w-full ${maxWidthClass} mx-auto mt-[10vh] mb-4 flex justify-center`}>
                            <div
                                className={`relative flex flex-col w-full ${maxWidthClass} rounded-xl border border-gray-100 shadow-xl bg-white outline-none focus:outline-none`}>
                                {children}
                            </div>
                        </div>
                    </div>
                    <div className="opacity-60 fixed inset-0 z-40 bg-gray-900"></div>
                </> : null}
        </>
    );
};

export default Modalstructure;